import type { ReactNode } from 'react';
import type { LevelResult } from '@dave/level-contract';

/** Окно результата уровня по UI-киту (§03): победа — teal-праздник,
 *  поражение — ржавый глитч Хардкода. Общее для PlayScreen и WildcardScreen
 *  (стили — meta.css); различаются только действия — их отдаёт экран. */
export function LevelResultPanel({ result, actions, testId, starsTestId }: {
  result: LevelResult;
  /** содержимое .result-actions — кнопки экрана («Далее»/«Ещё раз»/«К карте») */
  actions: ReactNode;
  testId: string;
  starsTestId: string;
}) {
  return (
    <div data-testid={testId} className="play-overlay">
      <div className={result.status === 'completed' ? 'result-panel win' : 'result-panel fail'}>
        <div className="result-badge" aria-hidden="true">
          {result.status === 'completed' ? '✓' : '▓'}
        </div>
        <h2 className="result-title">
          {result.status === 'completed' ? 'Отрефакторено!' : 'Баг остался…'}
        </h2>
        <p className="result-stars" data-testid={starsTestId}>
          {Array.from({ length: Math.max(result.maxRating, result.rating) }, (_, i) => (
            <span key={i} className={i < result.rating ? 'star earned' : 'star'}>
              {i < result.rating ? '★' : '☆'}
            </span>
          ))}
        </p>
        <div className="result-actions">{actions}</div>
        {result.status !== 'completed' && (
          <div className="result-glitch" aria-hidden="true">▓▒░ ▓ ▒░▓ ░▒ ▓▒░▓ ▒ ░▓▒ ░ ▓▒░ ▓ ▒░▓▒░</div>
        )}
      </div>
    </div>
  );
}
